import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Token storage: sessionStorage is per-tab and auto-clears on close.
// This is a fallback for browsers (notably iOS Safari) that silently reject
// Set-Cookie in some cross-site contexts under Intelligent Tracking Prevention.
// HttpOnly cookies remain the preferred and primary auth path.
const TOKEN_KEY = "calside_access_token";

export function setAccessToken(token) {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch { /* private-mode / disabled storage — ignore */ }
}

export function getAccessToken() {
  try { return sessionStorage.getItem(TOKEN_KEY); }
  catch { return null; }
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer token from sessionStorage on every request as a fallback
// for browsers that reject the httpOnly cookie. Also attach a custom
// X-Calside-CSRF header on every request — a cross-site attacker cannot
// set this header without a CORS preflight, which we reject for non-
// allowlisted origins. This is the CSRF defence for cookie-auth routes
// (SEC-001).
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  config.headers = config.headers || {};
  config.headers["X-Calside-CSRF"] = "1";
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
